import React from 'react';
import mainContext from '../../../contexts/mainContext';
import { addBabySitterSpecialistInController, deleteData, getBabySitterSpecialistInController } from '../../../Controllers/AppManagement/babySitter';
import { __constants, __snackBarText, __snackBarSeverity } from '../../../constants';
import ImageTextListManager from '../common/ImageTextListManager';

export default function BabySitterSpecialties() {
  const { setProfileNavTitle } = React.useContext(mainContext);
  return (
    <ImageTextListManager
      navTitle="Babysitter specialties"
      dialogTitle="Add new Specialty"
      textLabel="Specialty"
      getData={getBabySitterSpecialistInController}
      addData={addBabySitterSpecialistInController}
      deleteData={deleteData}
      editTitle="Update specialty"
      setProfileNavTitle={setProfileNavTitle}
      __constants={__constants}
      __snackBarText={__snackBarText}
      __snackBarSeverity={__snackBarSeverity}
      mainContext={mainContext}
    />
  );
}